<template>
  <div>
    <v-btn-toggle color="primary">
      <v-btn to="/suppliers"> الموردين </v-btn>
      <v-btn to="/suppSections"> الاقسام </v-btn>
      <v-btn to="/cities"> المدن </v-btn>
      <v-btn to="/languages"> اللغات </v-btn>
      <v-btn to="/translations"> الترجمة </v-btn>
      <v-btn to="/s_customers"> العملاء </v-btn>
      <v-btn to="/businessTypes">اقسام العملاء </v-btn>
      <v-btn to="/introPages"> التعريفية </v-btn>
      <v-btn @click="logout()"> خروج </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: "AdminMenu",
  methods: {
    logout() {
      let vm = this;
      this.$store.dispatch("logout");
      window.location.reload();
    },
  },
};
</script>
